import { ref } from "@nuxtjs/composition-api";
import Cookie from "cookie-universal";
const moduleOptions = JSON.parse(`{"gtmId":"G-VN70G77335"}`);
const cookieName = "cookieConsent";
function plugin_default(context, inject) {
  const $cookies = Cookie();
  const cookie = $cookies.get(cookieName);
  const consented = ref(!!cookie);
  const consentValue = cookie ? cookie : {
    analytics: true,
    marketing: true,
    preferences: true
  };
  const consentState = ref({
    analytics: consentValue.analytics,
    marketing: consentValue.marketing,
    preferences: consentValue.preferences
  });
  function updateConsent(state) {
    const gtm = context.app.$gtm;
    if (gtm && moduleOptions.gtmId && (state.analytics || state.marketing || state.preferences)) {
      gtm.init(moduleOptions.gtmId);
    }
    consentState.value = state;
    consented.value = true;
    $cookies.set(cookieName, state, {
      expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1e3)
    });
    const payload = {
      ad_personalization: state.marketing ? "granted" : "denied",
      ad_storage: state.marketing ? "granted" : "denied",
      analytics_storage: state.analytics ? "granted" : "denied",
      functionality_storage: "granted",
      security_storage: "granted",
      personalization_storage: state.preferences ? "granted" : "denied"
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(["consent", "update", payload]);
  }
  inject("cookieConsent", {
    consented,
    consentState,
    updateConsent
  });
}
export {
  plugin_default as default
};
